<template>
  <div v-show="show" class="search-results generic-border">
    <div v-if="search == ''" style="margin: 15px">{{ $t("message.TYPE_IN_SEARCH_FIELD") }}</div>
    <div v-else>
      <div>
        <div class="search-res-problems">
          <div class="search-category">{{ $t("message.PROBLEMS") }}</div>
          <div v-if="searching" class="search-results__text">{{ $t("message.SEARCHING_DOTS") }}</div>
          <div v-else>
            <div v-show="results.problems.length == 0" class="search-results__text">
              {{ $t("message.NO_MATCH_PROBLEMS") }}
            </div>
            <RecycleScroller
              v-slot="{ item }"
              :items="results.problems"
              :item-size="searchItemHeight"
              key-field="id"
              class="search-results__scroller"
            >
              <SearchItem type="problem" :value="item" />
            </RecycleScroller>
          </div>
          <div class="search-category">{{ $t("message.ACTIONS") }}</div>
          <div v-if="searching" class="search-results__text">{{ $t("message.SEARCHING_DOTS") }}</div>
          <div v-else>
            <div v-show="results.actions.length == 0" class="search-results__text">
              {{ $t("message.NO_MATCH_ACTIONS") }}
            </div>
            <RecycleScroller
              v-slot="{ item }"
              :items="results.actions"
              :item-size="searchItemHeight"
              key-field="id"
              class="search-results__scroller"
            >
              <SearchItem type="action" :value="item" />
            </RecycleScroller>
          </div>
          <div class="search-category">{{ $t("message.GW") }}</div>
          <div v-if="searching" class="search-results__text">{{ $t("message.SEARCHING_DOTS") }}</div>
          <div v-else>
            <div v-show="results.gembaWalks.length == 0" class="search-results__text">
              {{ $t("message.NO_MATCH_GW") }}
            </div>
            <RecycleScroller
              v-slot="{ item }"
              :items="results.gembaWalks"
              :item-size="searchItemHeight"
              key-field="id"
              class="search-results__scroller"
            >
              <SearchItem type="gembaWalk" :value="item" />
            </RecycleScroller>
          </div>
        </div>
        <div class="search-res-actions" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Search bar component with related HTTP requests
 */

import { RecycleScroller } from 'vue-virtual-scroller';

import SearchItem from '@/components/search-item.vue';

export default {

  name: 'SearchResults',

  components: {
    RecycleScroller,
    SearchItem,
  },

  props: {
    show: Boolean,
    search: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      searching: false,
      results: {
        problems: [],
        actions: [],
        gembaWalks: [],
      },
      durationThreshold: 600,
      timeout: null,
    };
  },

  computed: {
    searchItemHeight() {
      return 2 * this.$store.getters.fontSize;
    },
  },

  watch: {
    search() {
      this.searching = true;
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(this.refresh, this.durationThreshold);
    },
  },

  methods: {
    refresh() {
      this.$http.post('/server/actions/search.php', { text: this.search })
        .then((response) => {
          this.searching = false;
          if (typeof response.data === 'object') {
            this.results = {
              problems: response.data.problems || [],
              actions: response.data.actions || [],
              gembaWalks: response.data.gembaWalks || [],
            };
          }
        })
        .catch(() => {
          this.searching = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.search-results {
  position: fixed;
  top: 60px;
  width: 40%;
  right: 1rem;
  z-index: 10019;
  box-shadow: $dark-box-shadow;

  &__text {
    background: #efefef;
    padding: 0.3rem;
  }

  &__scroller {
    max-height: 12rem;
  }

  .search-category {
    color: $color-shizen-blue;
    padding: 1rem .5rem;
  }
}

/* Smartphone landscape */
@media (max-width: $smartphone-landscape) {
  .search-results {
    top: 35px;
    max-height: calc(100% - 35px);
    overflow: auto;
  }
}
</style>
